const isInArea = ({ x1, x2, y1, y2 }, { x, y }) => (
  (x - x1) * (x - x2) <= 0 && (y - y1) * (y - y2) <= 0
)

export default isInArea



// WEBPACK FOOTER //
// ./src/assets/js/isInArea.js